import { SearchIcon } from "@rivval/icons";
import { Button } from "@rivval/ui/button";
import { Input } from "@rivval/ui/input";

export function SearchBar({ className = "" }: { className?: string }) {
  return (
    <form action="/search" className={`flex items-center ${className}`}>
      <div className="relative flex">
        <Input
          type="search"
          name="query"
          placeholder="Search products..."
          className="h-9 w-[200px] rounded-r-none border-r-0 border-yellow-500 focus-visible:ring-yellow-500 lg:w-[300px]"
          required
          minLength={2}
        />
        <Button
          type="submit"
          size="sm"
          className="h-9 rounded-l-none border-yellow-500 bg-yellow-500 hover:border-yellow-600 hover:bg-yellow-600"
        >
          <SearchIcon className="h-4 w-4 text-black" />
          <span className="sr-only">Search</span>
        </Button>
      </div>
    </form>
  );
}
